(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/mobile-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/mobile-card.js');
'use strict';

const {
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const {
  WhiteCardHeader,
  PdCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  MobileConfirm,
  MobileFooter,
  MobileRemove,
  MobileSave,
  MobileText
} = svs.myProfile.react.pages.myInformation.myInformation.mobile;

const MobileCard = _ref => {
  let {
    isFocused = false
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const {
    cellPhoneStatus,
    cellphone
  } = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences) || {};
  const {
    setForceSaveMobile
  } = svs.myProfile.react.store.pdPreferences.actions;
  const isForceSaveMobile = ReactRedux.useSelector(state => state.playerPreferences.isForceSaveMobile) || false;
  const mobileVerified = cellPhoneStatus === '2';
  const mobileExists = Boolean(cellphone);
  const mobileRef = React.useRef(null);
  React.useEffect(() => {
    if (isFocused && mobileRef) {
      mobileRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isFocused]);
  const onChange = () => {
    dispatch(setForceSaveMobile(false));
  };
  return React.createElement("div", {
    className: "margin-v-1"
  }, React.createElement("div", {
    className: svs.core.detect.breakpoint.greaterThan('sm') ? 'scroll-margin-card' : 'scroll-margin-card-mobile',
    ref: mobileRef
  }, React.createElement(PdCard, {
    isFocused: isFocused,
    onChange: onChange
  }, React.createElement(WhiteCardHeader, {
    className: "mobile-number-header"
  }, "Mobilnummer"), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, React.createElement(MobileText, null)), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, mobileVerified || !mobileExists || isForceSaveMobile ? React.createElement(MobileSave, null) : React.createElement(MobileConfirm, null), mobileExists && React.createElement(MobileRemove, null), (!mobileExists || mobileVerified || isForceSaveMobile) && React.createElement(MobileFooter, null)))));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileCard = MobileCard;

 })(window);